import React from "react";
import WorkExperience from "./WorkExperience";
import ProfileDataCard from "./ProfileDataCard";

interface ApprenticeshipProps {
  apprenticeshipJob: string | null;
  apprenticeshipCompany: string | null;
  apprenticeshipLocation: string | null;
  apprenticeshipStart: Date | null;
  apprenticeshipEnd: Date | null;
}

/**
 * This component displays the apprenticeship of an applicant.
 * @param apprenticeshipJob The job title of the applicant.
 * @param apprenticeshipCompany The company the applicant worked for.
 * @param apprenticeshipLocation The location of the company.
 * @param apprenticeshipStart The start date of the apprenticeship.
 * @param apprenticeshipEnd The end date of the apprenticeship.
 * @returns The apprenticeship of the applicant.
 */
const Apprenticeship = ({
  apprenticeshipJob,
  apprenticeshipCompany,
  apprenticeshipLocation,
  apprenticeshipStart,
  apprenticeshipEnd,
}: ApprenticeshipProps) => {
  return (
    <ProfileDataCard title="Berufsausbildung">
      <WorkExperience
        jobTitle={apprenticeshipJob}
        company={apprenticeshipCompany}
        location={apprenticeshipLocation}
        start={apprenticeshipStart}
        end={apprenticeshipEnd}
      />
    </ProfileDataCard>
  );
};

export default Apprenticeship;
